function normalizeText(value: string): string {
  return value
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim();
}

export function messageIndicatesStudyPlanNotFound(message?: string): boolean {
  if (!message) return false;

  const normalizedMessage = normalizeText(message);
  const isPortugueseStudyPlanNotFound =
    normalizedMessage.includes('plano de estudo') && normalizedMessage.includes('nao encontrado');
  const isEnglishStudyPlanNotFound = normalizedMessage.includes('study plan not found');

  return isPortugueseStudyPlanNotFound || isEnglishStudyPlanNotFound;
}
